module.exports = __webpack_public_path__ + "static/media/maria2.e2fbde54.mp3";